import get from 'lodash/get'
import { usePermissions, useResourceContext } from 'react-admin'

export const hasResourcePermission = (permissions, resource, ...args) => {
  const resourcePermissions = get(permissions, ['resources', resource])
  if (!resourcePermissions) {
    return false
  }
  return [...args].every((permission) => (Object.keys(resourcePermissions) || []).includes(permission))
}

export const useResourcePermissions = (resource, ...args) => {
  const { permissions } = usePermissions()

  // Get the first part of the resource name (e.g. 'organisations/pressure' -> 'organisations')
  const match = resource.match(/^[^/]+/)
  const baseResource = match ? match[0] : resource

  return [...args].map((permission) =>
    permissions ? hasResourcePermission(permissions, baseResource, permission) : undefined,
  )
}

export const useIsFieldPermissionDenied = ({ action, source, ...props }) => {
  const { permissions } = usePermissions()
  const resource = useResourceContext(props)

  const currentActionPermissions = permissions?.resources[resource][action]
  if (currentActionPermissions === undefined) return true

  return currentActionPermissions.deny?.includes(source)
}
